<small class="debug">{{me}}</small>
<div class="playlist_properties">

  <!--    <app-video-link-->
  <!--            tooltip="{{'general.timeline' | transloco}}"-->
  <!--            style="position: fixed; top: -10px; width: 50px; height: 50px"-->
<!--            [videoLink]="'/help/Playlist'"></app-video-link>-->

<div class="clearFloat"></div>
@if (dynamicsInitialized) {
  <div>
    <dynamic-form
      [fields]="uiConfigInit"
      [ignoreValidation]="true"
      (submit)="submit($event)">
    </dynamic-form>
  </div>
}
</div>
